import { useEffect } from 'react';
import { ProcessingOverlay } from 'common/components/UI/ProcessingOverlay';
import { OAuthConfig } from 'common/types/api';
import { Api } from 'common/utils/api';
import FHIR from 'fhirclient';
import { useParams } from 'react-router-dom';

// SMART on FHIR launch initiator (Epic Standalone Launch SSO)
export const StandaloneSmartLaunch = () => {
    const { facilityId } = useParams<{ facilityId: string }>();
    const facilityIdNum: number = parseInt(facilityId ?? '') || 0;

    useEffect(() => {
        const fetchFacilityOAuthConfig = async () => {
            const body = { facilityId: facilityIdNum };
            return await Api.post<OAuthConfig>({ path: '/epic/facility-oauth-lookup', body });
        };

        fetchFacilityOAuthConfig().then(config =>
            FHIR.oauth2.authorize({
                clientId: config.clientId,
                iss: config.iss,
                scope: 'openid fhirUser launch launch/patient',
                redirectUri: `/smart-launch-handler/${config.redirectPath}`,
            })
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <ProcessingOverlay enabled caption="Connecting to Epic..." />;
};
